/** Product mockup: master box, 6 volumes, tablet dashboard and 5 bonus kits. */
export const heroImage =
  'https://cdn.magicpatterns.com/uploads/5ujN9AYH9nNJnqnX1TDVkB/ChatGPT_Image_24_sept_2026,_22_25_53-Photoroom.webp'

export const heroChecks: string[] = [
  '6 Complete Professional Volumes',
  '5 Command Kit Bonuses',
  'Immediate Access',
]

/** Checkout link. */
export const checkoutUrl =
  'https://the-coach-s-operating-system.impultienda.ar/checkout'

export const productName = 'The Coach’s Operating System™'
export const price = '$27'
export const priceValue = 27
export const launchAfterPrice = '$67'
export const volumesValue = '$120'
export const bonusValue = '$215'
export const fullPrice = '$335'
export const savings = '$308'
export const savingsPercent = '92%'

export const heroDescription =
  'The Coach’s Operating System™ — a complete 6-volume coaching system with 150+ ready-to-run sessions covering sprints, hurdles, jumps, throws, distance, race walking, program management and annual periodization — plus 5 command kits, all organized and ready to use.'

export const solutionStats =
  '150+ ready-to-run sessions · 5 command kits · Beginner to advanced · Ready to use today'

/** Everything included (final close). */
export const everythingIncluded: string[] = [
  '6 Complete Professional Volumes',
  '150+ Ready-to-Run Sessions',
  '5 Command Kit Bonuses',
  'Tier 1 to Tier 3 Progressions',
  'Immediate Access',
  'Printable PDF Format',
  '7-Day Guarantee',
  'Pay in Your Local Currency',
]

export const trustBadges: string[] = [
  '7-Day Guarantee',
  'Secure Payment',
  'Immediate Access',
  'PDF Format',
]

/** How the Operating System works — the three decisions a coach makes. */
export interface SystemStep {
  step: string
  title: string
  detail: string
  options: string[]
}

export const systemSteps: SystemStep[] = [
  {
    step: '1',
    title: 'Choose the event',
    detail: 'Open the volume for the group in front of you.',
    options: ['Sprints & Hurdles', 'Jumps', 'Throws', 'Distance & Walking'],
  },
  {
    step: '2',
    title: 'Choose the tier',
    detail: 'Match the session to where your athletes are right now.',
    options: ['Tier 1 · Beginner', 'Tier 2', 'Tier 3 · Advanced'],
  },
  {
    step: '3',
    title: 'Run the session',
    detail: 'Print it and walk onto the track with a plan.',
    options: ['Coaching cues', 'Progressions', 'Assessment rubric'],
  },
]

export const builtFor: string[] = [
  'High school coaches',
  'Club coaches',
  'University coaches',
  'PE teachers',
  'Solo coaches',
]

/** What the system gives you. */
export const heroBenefits: string[] = [
  '150+ ready-to-run sessions across every event',
  'Progressions from Tier 1 (Beginner) to Tier 3 (Advanced)',
  'Coaching cues for every drill',
  'Systems for mixed groups, large teams and solo coaches',
]

/** Sunday, 6 PM — what coaches are still doing. */
export const sundayStruggles: string[] = [
  'Searching YouTube for drills that fit your program',
  'Guessing jump progressions, throw counts and distance intensity',
  'Juggling multiple event groups at once',
  'Repeating the same drills because they’re the only ones you trust',
]

export interface PainRow {
  problem: string
  impact: string
}

export const painRows: PainRow[] = [
  {
    problem: 'Hours spent planning individual sessions',
    impact: 'Your preparation time doubles. Your confidence drops.',
  },
  {
    problem: 'Repeating the same drills week after week',
    impact: 'Athletes stop progressing. Boredom sets in.',
  },
  {
    problem: 'Random exercises without a progression pathway',
    impact: 'Training becomes busy instead of purposeful.',
  },
  {
    problem: 'Different event groups competing for your attention',
    impact: 'Practice becomes chaotic. Quality suffers.',
  },
  {
    problem: 'Competition weeks built from scratch every time',
    impact: 'Fatigue spikes. Athletes underperform.',
  },
]

/** Solution intro. */
export const notThis: string[] = [
  'This is not just another collection of drills copied from YouTube.',
  'This is not a theoretical manual that leaves you wondering how to apply it.',
  'This is not a one-event program that ignores the complexity of track and field.',
]

export interface Contrast {
  want: string
  instead: string
}

export const solutionPillars: Contrast[] = [
  { want: 'Structure', instead: 'not chaos' },
  { want: 'Clarity', instead: 'not confusion' },
  { want: 'Progressions', instead: 'not random exercises' },
  { want: 'Time', instead: 'not endless planning' },
  { want: 'Confidence', instead: 'not improvisation' },
]

/** Final close: Option A vs Option B. */
export const optionA: string[] = [
  'Search for drills on YouTube',
  'Improvise competition weeks',
  'Spend Sundays planning',
]

export const optionB: string[] = [
  'Choose event + level, open the session',
  'Progressions ready for every correction',
  'Reclaim your Sundays and your confidence',
]

export interface TrustSignal {
  icon: 'access' | 'pages' | 'sessions' | 'bonuses' | 'guarantee' | 'updates'
  label: string
}

export const trustSignals: TrustSignal[] = [
  { icon: 'access', label: 'Immediate Digital Access' },
  { icon: 'pages', label: '6 Professional Volumes' },
  { icon: 'sessions', label: '150+ Ready-to-Run Sessions' },
  { icon: 'bonuses', label: '5 Exclusive Bonuses Included' },
  { icon: 'guarantee', label: '7-Day Satisfaction Guarantee' },
  { icon: 'updates', label: 'Lifetime Access to Updates' },
]
